/* Actualizeaza bulinele cand utilizatorul da swipe pe imaginea produsului.
   Listener delegat: functioneaza si pe produsele incarcate de infinite scroll. */
(function () {
  'use strict';
  document.addEventListener('scroll', function (e) {
    var mask = e.target;
    if (!mask || !mask.classList ||
        !mask.classList.contains('grid-product__image-mask')) return;
    var dots = mask.parentNode
      ? mask.parentNode.querySelector('.grid-swipe-dots') : null;
    if (!dots || dots.children.length < 2) return;
    var onSecond = mask.scrollLeft > mask.clientWidth / 2;
    dots.children[0].classList.toggle('is-active', !onSecond);
    dots.children[1].classList.toggle('is-active', onSecond);
  }, true);
})();